enum ListBoxModifier {
  RELATIVE = 'combobox__listbox--relative',
  MAX_HEIGHT_200 = 'combobox__listbox--max-height-200',
}
export default ListBoxModifier;
